import { connect } from 'react-redux'
import { TagsViewer } from '../components'
import { selectors } from '../'

const mapStateToProps = (state, props) => ({
  tags: selectors.getTags(state, props.Id).filter((tag) => tag.IsActive),
})

export default connect(mapStateToProps)(TagsViewer)
